export enum UserRoleEnum {
  SuperAdmin = 1,
  UserAdmin,
  SuperViewer,
};
